module.exports = __webpack_public_path__ + "img/sprite-2.630001b0.webp";